import { IconSlash, IconCheckCircle } from '../../ui'
import { ERoleExtraIsBuyer } from '../../../types/enum'


type IRoleExtraIsBuyerIcon = {
	value: ERoleExtraIsBuyer | null;
}
export const RoleExtraIsBuyerIcon = ({ value }: IRoleExtraIsBuyerIcon) => {
	let icon

	switch (value) {
		case ERoleExtraIsBuyer.Buyer: {
			// IconCheckCircle for 'Buyer' roleExtra
			icon = <IconCheckCircle size={20} stroke={`var(--successColor, black)`}/>
			break
		}
		case ERoleExtraIsBuyer.NotBuyer: {
			// IconSlash for 'NotBuyer' roleExtra
			icon = <IconSlash size={20}/>
			break
		}
		default: {
			icon = null
			break
		}
	}

	return icon
}